// extracted by mini-css-extract-plugin
export default {"pageContent":"style_pageContent__liBFs"};